<template>
  <div
    class="flex flex-col gap-5"
    v-show="featureIndex % 4 === featureColumnChangeFactor"
  >
    <p class="flex items-center gap-3">
      <i class="fa-solid text-green-500 text-xl" :class="featureIcon"></i>
      {{ featureHeadLine }}
    </p>
    <br />
  </div>
</template>

<script setup>
import { defineProps, toRef } from "vue";

const props = defineProps({
  featureHeadLine: {
    type: String,
    required: true,
  },
  featureIcon: {
    type: String,
    required: true,
  },
  featureIndex: {
    type: Number,
    required: true,
  },
  featureColumnChangeFactor: {
    type: Number,
    required: true,
  },
});

const featureHeadLine = toRef(props, "featureHeadLine");
const featureIcon = toRef(props, "featureIcon");
const featureIndex = toRef(props, "featureIndex");
</script>
